import startCase from 'lodash/startCase';

const formatSlug = string => startCase(string);

export default formatSlug;
